<template lang="html">

    <section class="contenedor-error row-center" v-if="!!error" :show="!!errorcode" :type="error.categoria">
        
        <div class="popup">

            <a @click="close" class="close" v-if="(error.categoria != 'important' && !!!error.es.to)">✕</a>

            <h3 class="title-error">{{error.es.titulo}}</h3>

            <p>{{error.es.cuerpo}}</p>

            <a class="btn" @click="logout" v-if="error.categoria == 'important'">Aceptar</a>
            <a class="btn" @click="close" v-if="error.categoria == 'medium' && !!!error.es.to">Aceptar</a>
            <a class="btn" @click="goto(error.es.to)" v-if="!!error.es.to">Aceptar</a>

        </div>

    </section>

</template>

<script lang="js">

    import {mapActions, mapGetters} from 'vuex';

    import data from '@/errors';

    import router from '@/router';

    export default {
        name: 'error-banner',
        mounted(){
            this.errorslist = data;
        },  
        data(){
            return{
                errorslist : ''
            }
        },
        computed : {
            ...mapGetters({
                errorcode : 'getErrorCode'
            }),
            error(){
                if(!!this.errorslist){
                    return this.errorslist[this.errorcode];
                }
            }
        },
        methods : {
            ...mapActions(['eraseError']),
            close(){
                this.eraseError();
            },
            goto(to){
                this.close();
                router.push(to);
            },
            logout(){
                this.eraseError();
                router.push({name : "logout"})
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/parts/error-banner.vue